import './api/setupAxios';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { CacheProvider } from '@emotion/react';
import emotionCache from './emotionCache';
import { HelmetProvider } from 'react-helmet-async';
import 'leaflet/dist/leaflet.css';
import './setupPromiseDebug';

const theme = extendTheme({});

// Ripulisce i tag <title>/<meta>/<link>/<script type="application/ld+json">
// gia' presenti nell'HTML statico (scritto da scripts/prerender.cjs per i
// crawler che non eseguono JS) PRIMA che React monti l'app. Motivo: da
// react-helmet-async 3.0.0 in poi, <Helmet> non gestisce piu' il DOM in
// autonomia ma si appoggia al supporto nativo di React 19 per "sollevare"
// title/meta/link nell'head — e quel meccanismo non rimuove i tag gia'
// presenti, li aggiunge soltanto. Risultato: title/description/canonical
// duplicati (a volte annidati) ad ogni caricamento in un browser reale, pur
// restando corretto e singolo nel file HTML grezzo. Bug noto e mai risolto
// a monte: https://github.com/staylor/react-helmet-async/issues/266
// Rimuovendo qui i tag statici prima del primo render, il <Helmet> di ogni
// pagina parte da un head pulito e non duplica piu' nulla.
function pulisciTagPrerenderizzati() {
    const selettori = [
        'title',
        'meta[name="description"]',
        'meta[name="keywords"]',
        'meta[name="robots"]',
        'meta[name^="twitter:"]',
        'meta[property^="og:"]',
        'meta[property^="article:"]',
        'link[rel="canonical"]',
        'script[type="application/ld+json"]',
    ];
    selettori.forEach((sel) => {
        document.head.querySelectorAll(sel).forEach((el) => el.remove());
    });
}
pulisciTagPrerenderizzati();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <HelmetProvider>
            <CacheProvider value={emotionCache}>
                <ChakraProvider theme={theme}>
                    <App />
                </ChakraProvider>
            </CacheProvider>
        </HelmetProvider>
    </React.StrictMode>
);
